/**
 * Campus (single-school / principal) Dashboard — static config.
 *
 * The campus dashboard reuses the head-office widgets verbatim and feeds them
 * LIVE data from the campus `*-v1` endpoints (see useCampusData + apiMappers).
 * The only static piece here is the widget catalogue (labels/keys).
 */

import { WidgetMeta } from "../headOffice/data";

export type { WidgetKey, WidgetMeta } from "../headOffice/data";

/* ------------------------------------------------------------------ *
 * Widget catalogue — same keys as head office, campus-scoped labels.
 * ------------------------------------------------------------------ */

export const CAMPUS_WIDGET_META: WidgetMeta[] = [
  /* order matches the dashboard layout — the first 5 are fixed (never hideable) */
  { key: "kpi", label: "Campus at a Glance", group: "core", hint: "5 totals" },
  { key: "growth", label: "Reading Growth Trends", group: "core", hint: "line chart" },
  { key: "mix", label: "Reading Mix", group: "core", hint: "genre/lang" },
  { key: "campuses", label: "The Reader Classrooms", group: "core", hint: "ranked" },
  { key: "adoption", label: "Adoption Rate", group: "core", hint: "gauge" },
  { key: "teachers", label: "Top Teachers", group: "proposed", hint: "ranked" },
  { key: "students", label: "Top Students", group: "proposed", hint: "ranked" },
  { key: "content", label: "Books & Content Analytics", group: "proposed", hint: "breakdown" },
  { key: "teacherAdoption", label: "Teacher Adoption", group: "proposed", hint: "quiz pass" },
  { key: "comparison", label: "Classroom Comparison", group: "proposed", hint: "heatmap" },
  { key: "assignment", label: "Assignment Pipeline", group: "proposed", hint: "donut" },
];
